module.exports = __webpack_public_path__ + "img/status-2.a8d9ce11.png";